
var sprite = require("/data/jenkins/jobs/deploy_web_common_h5_pipeline/workspace/fe-h5/smart-form/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 48 48\" id=\"check-circle-o\" ><g fill-rule=\"evenodd\"><path d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z\"/><path d=\"M12.2 23.2L10 25.3l10 9.9L37.2 15 35 13 19.8 30.8z\"/></g></symbol>";
module.exports = sprite.add(image, "check-circle-o");


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/assets/check-circle-o.svg
// module id = 480
// module chunks = 0 1